export class DeviceUtils {
    static checkDeviceType(): boolean {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.includes('mobi') || userAgent.includes('android') || userAgent.includes('iphone')) {
            return true;
        } else {
            return false;
        }
    }
}
